var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graduation-hat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.999,
    height: 23.923,
    viewBox: "0 0 27.999 23.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M28,54.371a2.457,2.457,0,0,0-1.641-2.31v-8.5L28,42.887,14,37.27,0,42.887,14,48.5l10.718-4.282v7.839a2.446,2.446,0,0,0-.235,4.524L23.12,60.674l1.556.519.863-2.588.863,2.588,1.556-.519-1.363-4.089A2.457,2.457,0,0,0,28,54.371Z",
    transform: "translate(0 -37.27)",
    fill: "#324562"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(6.617 10.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M128.383,223.784,121,220.82v2.142c0,2.338,3.174,4.1,7.383,4.1s7.383-1.763,7.383-4.1V220.82Z",
    transform: "translate(-121 -220.82)",
    fill: "#324562"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.bf79f6de476fc80edf821474be4ef90a.svg";
export { ForwardRef as ReactComponent };